import { useCallback, useEffect, useState } from 'react'

import { fetchAplDocuments } from '../api/fetchAplDocuments'
import { START_FROM_TODAY } from '../components/uploadForm/configs'
import { getLastUploadDate } from '../helpers/getLastUploadDate'
import { IAplDocument } from '../models/aplDocument'

export const useAplDocuments = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [lastUploadDate, setLastUploadDate] = useState(START_FROM_TODAY)
  const [aplDocuments, setAplDocuments] = useState<IAplDocument[]>([])

  const fetchDocuments = useCallback(async () => {
    setIsLoading(true)
    const result = await fetchAplDocuments()
    setLastUploadDate(getLastUploadDate(result))
    setAplDocuments(result)
    setIsLoading(false)
  }, [])

  useEffect(() => {
    fetchDocuments()
  }, [fetchDocuments])

  return {
    lastUploadDate,
    aplDocuments,
    fetchDocuments,
    isLoading,
  }
}
